import React from 'react';
import { connect } from 'react-redux';
import { LayoutCard } from '@beef/landing-constructor';
import { compose } from '@beef/utils';
import { NText } from '@fttb/common/components';
import { getInfoCardFootnote, getInfoCardsList } from "../../store/blocks/infoCards/selectors";
import { getAnalyticEventType } from "../../store/blocks/selectors";
import { openInfoCardModalAnalytics } from "../../store/infoCards/actions";
import { InfoCardsModal } from "./components";
import { FttbBlocks } from "../constants";
import { addOnClickForInfoCard, defineBlock } from "../utils";
var _InfoCardsBlock = function _InfoCardsBlock(_ref) {
  var className = _ref.className,
    content = _ref.content,
    footnote = _ref.footnote,
    onClick = _ref.onClick;
  var cards = addOnClickForInfoCard(content, onClick);
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-t-id": "blocks-InfoCardsBlock"
  }, /*#__PURE__*/React.createElement(LayoutCard, {
    content: cards,
    type: "infoCard"
  }), /*#__PURE__*/React.createElement(InfoCardsModal, null), footnote && /*#__PURE__*/React.createElement(NText, {
    className: "mar-t-2xl",
    color: "grey60",
    isInline: false,
    size: "size6-m"
  }, footnote));
};
var mapDispatchToProps = {
  onClick: openInfoCardModalAnalytics
};
export var InfoCardsBlock = compose(connect(function (state) {
  return {
    content: getInfoCardsList(state),
    footnote: getInfoCardFootnote(state),
    pageType: getAnalyticEventType(state)
  };
}, mapDispatchToProps), defineBlock(FttbBlocks.INFO_CARDS))(_InfoCardsBlock);